import type { IInitialFormValues, TFormType } from '../types';

const handleHubspotDemoSuccess = (values: IInitialFormValues, form: TFormType) => {
  window?.heap?.track?.('HubSpot Demo Marketing Form Success', {
    emailAddress: values?.email ?? '',
    formName: form,
    host: process.env.GATSBY_HOST ?? '',
    siteName: process.env.SITE_NAME ?? '',
    formGuid: process.env.GATSBY_DEMO_FORMGUID ?? '',
    portalId: process.env.GATSBY_DEMO_FORM_PORTALID ?? '',
    countryIndicatedAtSignup: values?.country_indicated_at_signup ?? '',
    conversionPage: values?.conversion_page ?? '',
  });
};

export default handleHubspotDemoSuccess;
